import { render, staticRenderFns } from "./ModificaQuestionarioCompilato.vue?vue&type=template&id=271e4479&"
import script from "./ModificaQuestionarioCompilato.vue?vue&type=script&lang=js&"
export * from "./ModificaQuestionarioCompilato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports